import { IBookingResponse } from "../../Orchestrator/Types/Index";

/**
 * Infant–adult linking (backend-set, read-only).
 * An infant travelling on a lap has a place-sharing reservation carrying
 * `guardianPassengerId` (see retailer.json Reservation schema). This is the
 * single source of truth for WHICH adult carries WHICH infant — never derive
 * the pairing from age/discount-card heuristics.
 */

/** infantPassengerId -> guardianPassengerId across all booked offers. */
export const getInfantGuardianMap = (
    booking?: IBookingResponse | null
): Map<string, string> => {
    const map = new Map<string, string>();
    booking?.booking?.bookedOffers?.forEach((offer: any) => {
        offer?.reservations?.forEach((reservation: any) => {
            const guardianId = reservation?.guardianPassengerId;
            if (guardianId && Array.isArray(reservation?.passengerIds)) {
                reservation.passengerIds.forEach((pId: string) => {
                    if (pId && pId !== guardianId) {
                        map.set(pId, guardianId);
                    }
                });
            }
        });
    });
    return map;
};

/** Ids of infants linked to the given carrying adult ([] when none). */
export const getLinkedInfantIds = (
    booking: IBookingResponse | null | undefined,
    guardianId: string
): string[] =>
    Array.from(getInfantGuardianMap(booking))
        .filter(([, gId]) => gId === guardianId)
        .map(([infantId]) => infantId);
